import React, {
  useEffect,
  useState,
  useMemo,
  useCallback
} from "react";
import { connect } from "react-redux";
import VWModel from "../../components/vwModal/vwModal";
import {
  closeCreateOrganisationModal,
  getOrganisations,
  openCreateOrganisationModal,
  setPageSizeGlobal,
} from "../../store/organisation/actions";
import Skeleton from "../../components/vwSkeleton/vwSkeleton";
import { Link } from "react-router-dom";
import {
  Badge,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Input,
  Spinner,
  Table
} from "reactstrap";
import AddOrganisation from "./AddOrganisation";
import { getPager } from "../../helper/common";
import NoRecord from "../../components/NoRecords/noRecords";
import VWPagination from "../../components/vwPagination/vwPagination";
import Message from "../../CommonData/Data/Message";
import VWLoading from "../../components/vwLoading/vwLoading";
import moment from "moment";
import debounce from "lodash/debounce";
import "../FixedColumn.css";

const style = {
  table: {
    width: '100%',
    display: 'table',
    borderSpacing: 0,
    borderCollapse: 'separate',
  },
  th: {
    top: 0,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#fff',
  },
};

const OrganisationList = (props) => {

  const { isCreateOrganisationModalOpen, errorMessage, isOrgCreate } = props;
  const [pageSize, setPageSize] = useState(10);
  const [pager, setPager] = useState({ currentPage: 1 });
  const [filter, setFilter] = useState();
  const [filterDisplay, setFilterDisplay] = useState();

  const buildQueryName = () => {
    const { name } = filter || {};
    let searchName = '';
    if (name) {
      searchName += `${name}`;
    }
    return searchName
  }

  const buildQueryOrgType = () => {
    const { orgType } = filter || {};
    let searchOrgType = '';
    if (orgType) {
      searchOrgType += `${orgType}`;
    }
    return searchOrgType
  }

  const buildQueryUserCount = () => {
    const { userCount } = filter || {};
    let searchUserCount = '';
    if (userCount) {
      searchUserCount += `${userCount}`;
    }
    return searchUserCount
  }

  const buildQueryDeviceCount = () => {
    const { deviceCount } = filter || {};
    let searchDeviceCount = '';
    if (deviceCount) {
      searchDeviceCount += `${deviceCount}`;
    }
    return searchDeviceCount
  }


  const buildQueryAddress = () => {
    const { address } = filter || {};
    let searchAddress = '';
    if (address) {
      searchAddress += `${address}`;
    }
    return searchAddress
  }
  const buildQueryActive = () => {
    const { active } = filter || {};
    let searchActive = '';
    if (active) {
      searchActive += `${active}`;
    }
    return searchActive
  }
  const buildQueryApproveNewCustomer = () => {
    const { approveNewCustomer } = filter || {};
    let searchApproveNewCustomer = '';
    if (approveNewCustomer) {
      searchApproveNewCustomer += `${approveNewCustomer}`;
    }
    return searchApproveNewCustomer
  }
  const buildQueryAllowCustomerSelfRegistration = () => {
    const { allowCustomerSelfRegistration } = filter || {};
    let searchAllowCustomerSelfRegistration = '';
    if (allowCustomerSelfRegistration) {
      searchAllowCustomerSelfRegistration += `${allowCustomerSelfRegistration}`;
    }
    return searchAllowCustomerSelfRegistration
  }
  const buildQueryEnableUserMailNotification = () => {
    const { enableUserMailNotification } = filter || {};
    let searchEnableUserMailNotification = '';
    if (enableUserMailNotification) {
      searchEnableUserMailNotification += `${enableUserMailNotification}`;
    }
    return searchEnableUserMailNotification
  }
  const buildQueryCreatedDateTime = () => {
    const { createdDateTime } = filter || {};
    let searchCreatedDateTime = '';
    if (createdDateTime) {
      searchCreatedDateTime += `${createdDateTime}`;
    }
    return searchCreatedDateTime
  }

  const handleClose = () => {
    const { closeCreateOrganisationModal } = props;
    closeCreateOrganisationModal();
  };

  const handleOpenCreateOrganisation = () => {
    const { openCreateOrganisationModal } = props;
    openCreateOrganisationModal();
  };

  // const handleSearch = (e) => {
  //   const input = e.target;
  //   const value = input.value;
  //   setFilter({
  //     ...filter,
  //     [input.name]: value
  //   })
  // }

  useEffect(() => {
    if (filter) {
      handleSearchClick();
    }
  }, [filter, isOrgCreate])

  const handleSearchClick = () => {
    setPage();
  }
  const sendBackendRequest = useCallback((name, value) => {
    setFilter((prevState) => ({
      ...prevState,
      [name]: value
    }));
  }, []);

  const debouncedSendRequest = useMemo(() => {
    return debounce(sendBackendRequest, 1000);
  }, [sendBackendRequest]);

  const handleSearch = (event) => {
    const input = event.target;
    const { value, name } = input;
    debouncedSendRequest(name, value)
    setFilterDisplay({
      ...filterDisplay,
      [name]: value
    });
  }
  useEffect(() => {
    const currentPager = getPager(props.totalRecords, 1, pageSize);
    setPager(currentPager)
  }, [props.totalRecords, pageSize])

  const setPage = (page = 1) => {
    props.getOrganisationsList(page, pageSize, buildQueryName(), buildQueryOrgType(), buildQueryUserCount(), buildQueryDeviceCount(), buildQueryAddress(),
      buildQueryActive(), buildQueryApproveNewCustomer(), buildQueryAllowCustomerSelfRegistration(), buildQueryEnableUserMailNotification(),
      buildQueryCreatedDateTime(), sortDirection, sortOrder);
    setPager(prevPager => {
      const totalPages = Math.ceil(props.totalRecords / pageSize);
      const visiblePages = 5;
      const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
      const newPages = [];
      for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
        newPages.push(i);
      }
      return {
        ...prevPager,
        currentPage: page,
        totalPages,
        pages: newPages,
        pageSize
      };
    });
  }

  // useEffect(() => {
  //   const currentPageNumber = pager && pager.currentPage
  //   setPage(currentPageNumber)
  // }, [])

  useEffect(() => {
    setPage();
    props.setPageSizeGlobal(pageSize)
  }, [pageSize])

  const [sortDirection, setSortDirection] = useState('asc');
  const [sortOrder, setSortOrder] = useState(null);

  const handleSort = (column) => {
    if (sortOrder === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortOrder(column);
      setSortDirection('asc');
    }
  };
  useEffect(() => {
    if (sortOrder && sortDirection) {
      setPage();
    }
  }, [sortOrder, sortDirection])
  return (
    <React.Fragment>
      <div className="page-content">
        <Card>
          <CardTitle
            className="p-2 pb-0 d-flex justify-content-between align-items-center fs-5 text-dark fw-bold">
            ORGANIZATION
            <Link
              type="button"
              className="mr-1 btn btn-primary btn-sm"
              // to="add"
              onClick={handleOpenCreateOrganisation}
            >
              <em className="fas fa-plus me-2"></em>Create Organization
            </Link>
          </CardTitle>
        </Card>
        <Card className='p-2'>
          {errorMessage && (
            <Message
              type="danger"
              defaultMessage={errorMessage}
              baseClassName="alert"
            />
          )}
          <div style={{ maxHeight: "500px", overflowX: "auto" }}>
            <Table className="table table-hover table-nowrap w-100 " size="sm" style={style.table}>
              <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: '10' }}>
                <tr>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('name')}>
                    ORGANIZATION NAME
                    {sortOrder === 'name' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('orgType')}>
                    ORGANIZATION TYPE
                    {sortOrder === 'orgType' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('userCount')}>
                    USERS
                    {sortOrder === 'userCount' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('deviceCount')}>
                    DEVICES
                    {sortOrder === 'deviceCount' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('createdDateTime')}>
                    CREATED ON
                    {sortOrder === 'createdDateTime' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} onClick={() => handleSort('address')}>
                    ADDRESS
                    {sortOrder === 'address' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} className="text-center" onClick={() => handleSort('active')}>
                    ACTIVE STATUS
                    {sortOrder === 'active' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} className="text-center" onClick={() => handleSort('approveNewCustomer')}>
                    APPROVAL STATUS
                    {sortOrder === 'approveNewCustomer' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} className="text-center" onClick={() => handleSort('allowCustomerSelfRegistration')}>
                    SELF-REGISTRATION STATUS
                    {sortOrder === 'allowCustomerSelfRegistration' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th style={{ cursor: "pointer" }} className="text-center" onClick={() => handleSort('enableUserMailNotification')}>
                    CUSTOMER NOTIFICATION STATUS
                    {sortOrder === 'enableUserMailNotification' && (
                      <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                    )}
                  </th>
                  <th className="text-center sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "20" }}>
                    VIEW
                  </th>
                </tr>
                <tr>
                  <th>
                    <FormGroup>
                      <Input
                        className='form-control'
                        size='sm'
                        name='name'
                        placeholder='search'
                        onChange={handleSearch}
                        value={(filterDisplay && filterDisplay.name) || ""}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        className='form-control'
                        type="select"
                        size='sm'
                        name='orgType'
                        placeholder='search'
                        onChange={handleSearch}
                        value={(filterDisplay && filterDisplay.orgType) || ""}
                      >
                        <option value="">Select</option>
                        <option value="general">General</option>
                        <option value="manufacturer">Manufacturer</option>
                      </Input>
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        style={{ minWidth: "60px" }}
                        className='form-control'
                        type='number'
                        size='sm'
                        name='userCount'
                        placeholder='search'
                        onChange={handleSearch}
                        value={(filterDisplay && filterDisplay.userCount) || ""}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        className='form-control'
                        type='number'
                        size='sm'
                        name='deviceCount'
                        placeholder='search'
                        onChange={handleSearch}
                        value={(filterDisplay && filterDisplay.deviceCount) || ""}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        className="form-control"
                        style={{ minWidth: "100px" }}
                        type='date'
                        size='sm'
                        name="createdDateTime"
                        onChange={handleSearch}
                        value={(filterDisplay && filterDisplay.createdDateTime) || ""}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        className='form-control'
                        size='sm'
                        name='address'
                        placeholder='search'
                        onChange={handleSearch}
                        value={(filterDisplay && filterDisplay.address) || ""}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        className="form-control"
                        style={{ minWidth: "100px" }}
                        type='select'
                        size='sm'
                        name="active"
                        onChange={handleSearch}
                        value={filterDisplay ? filterDisplay.active : ""}
                      >
                        <option value="">Select</option>
                        <option value={true}>Active</option>
                        <option value={false}>Inactive</option>
                      </Input>
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        className="form-control"
                        style={{ minWidth: "100px" }}
                        type='select'
                        size='sm'
                        name="approveNewCustomer"
                        onChange={handleSearch}
                        value={filterDisplay ? filterDisplay.approveNewCustomer : ""}
                      >
                        <option value="">Select</option>
                        <option value={true}>Enabled</option>
                        <option value={false}>Disabled</option>
                      </Input>
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        className="form-control"
                        style={{ minWidth: "100px" }}
                        type='select'
                        size='sm'
                        name="allowCustomerSelfRegistration"
                        onChange={handleSearch}
                        value={filterDisplay ? filterDisplay.allowCustomerSelfRegistration : ""}
                      >
                        <option value="">Select</option>
                        <option value={true}>Enabled</option>
                        <option value={false}>Disabled</option>
                      </Input>
                    </FormGroup>
                  </th>
                  <th>
                    <FormGroup>
                      <Input
                        className="form-control"
                        style={{ minWidth: "100px" }}
                        type='select'
                        size='sm'
                        name="enableUserMailNotification"
                        onChange={handleSearch}
                        value={filterDisplay ? filterDisplay.enableUserMailNotification : ""}
                      >
                        <option value="">Select</option>
                        <option value={true}>Enabled</option>
                        <option value={false}>Disabled</option>
                      </Input>
                    </FormGroup>
                  </th>
                  <th className="sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "20" }}></th>
                </tr>
              </thead>
              <tbody>
                {(props.organisationList && props.organisationList.length > 0) && !props.isGetOrganisationPending ?
                  (props.organisationList.map((data, index) =>
                    <tr key={index}>
                      <td>{data.name || "NA"}</td>
                      <td className="text-capitalize">{data.orgType || "NA"}</td>
                      <td align="center">{data.userCount || "NA"}</td>
                      <td align="center">{data.deviceCount || "NA"}</td>
                      <td>{data.createdDateTime ? moment(data.createdDateTime).format("DD MMM YYYY") : "NA"}</td>
                      <td className="text-nowrap">{data.address || "NA"}</td>
                      <td className="text-center">
                        {data.active ? (
                          <Badge color="success">Active</Badge>
                        ) : (
                          <Badge color="danger">Inactive</Badge>
                        )}
                      </td>
                      <td className="text-center">
                        {data.approveNewCustomer ? (
                          <Badge color="success">Enabled</Badge>
                        ) : (
                          <Badge color="danger">Disabled</Badge>
                        )}
                      </td>
                      <td className="text-center">
                        {data.allowCustomerSelfRegistration ? (
                          <Badge color="success">Enabled</Badge>
                        ) : (
                          <Badge color="danger">Disabled</Badge>
                        )}
                      </td>
                      <td className="text-center">
                        {data.enableUserMailNotification ? (
                          <Badge color="success">Enabled</Badge>
                        ) : (
                          <Badge color="danger">Disabled</Badge>
                        )}
                      </td>
                      <td className="text-center sticky-column bg-white">
                        <Link
                          type="button"
                          className="btn btn-sm btn-light"
                          to={`/orglist/details/${data.id}`}
                        >
                          <em className="far fa-share-square"></em>
                        </Link>
                      </td>
                    </tr>
                  ))
                  : props.isGetOrganisationPending ? (
                    <tr>
                      <td colSpan={11} align='center' className="p-4">
                        <Skeleton type="body" />
                        {/* <VWSpinner /> */}
                        <VWLoading />
                      </td>
                    </tr>
                  ) :
                    <tr>
                      <td colSpan={11}>
                        <NoRecord />
                      </td>
                    </tr>
                }
              </tbody>
            </Table>
          </div>
          <CardFooter>
            {props.organisationList && props.organisationList.length > 0 ?
              <VWPagination
                pager={pager}
                setPage={setPage}
                totalRecords={props.totalRecords}
                pageSize={pageSize}
                setPageSize={setPageSize}
              />
              : null
            }
          </CardFooter>
        </Card>
        <VWModel
          header="ADD ORGANIZATION"
          isOpen={isCreateOrganisationModalOpen}
          modalSize='large'
          handleClose={handleClose}
        >
          <AddOrganisation handleClose={handleClose} />
        </VWModel>
      </div>
    </React.Fragment >
  )
}

const mapStateToProps = (state) => ({
  isCreateOrganisationModalOpen: state.organisation.isCreateOrganisationModalOpen,
  organisationList: state.organisation.organisations,
  totalRecords: state.organisation.organisationsCount,
  errorMessage: state.organisation.orgListError,
  isGetOrganisationPending: state.organisation.isGetOrganisationPending,
  isOrgCreate: state.organisation.isOrgCreate,
});

const mapDispatchToProps = (dispatch) => ({
  openCreateOrganisationModal: () => dispatch(openCreateOrganisationModal()),
  closeCreateOrganisationModal: () => dispatch(closeCreateOrganisationModal()),
  setPageSizeGlobal: (pageSize) => dispatch(setPageSizeGlobal(pageSize)),
  getOrganisationsList: (page, pageSize, searchName, searchOrgType, searchUserCount, searchDeviceCount, searchAddress, searchActive, searchApproveNewCustomer, searchAllowCustomerSelfRegistration, searchEnableUserMailNotification, searchCreatedDateTime, sortDirection, sortOrder) =>
    dispatch(getOrganisations(page, pageSize, searchName, searchOrgType, searchUserCount, searchDeviceCount, searchAddress, searchActive, searchApproveNewCustomer, searchAllowCustomerSelfRegistration, searchEnableUserMailNotification, searchCreatedDateTime, sortDirection, sortOrder)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationList);

